/* eslint-disable */
import $ from "jquery";
import { getFileExtension, getFileName } from "../../utils/file";

// remove "c:\fakepath\" for file name in IE & Chrome
function removeFakePath(fileName) {
    return fileName.split('\\').pop();
}

const enterKey = 13;

$.widget("qs.fakeUpload", {
    options: {
        btnClass: "btn",
        inputClass: "text_box",
        commonEPStyle: true,
        extraClass: '',
        buttonText: 'Choose file',
        defaultTxt: 'No file',
        tabindex : 0
    },
    _create: function () {
        this.fakeInput = null;
        this.fakeButton = null;
        this.fakeText = null;
        this._render();
    },
    _render: function () {
        var _this = this;
        var titleTxt = this.element.attr('title') ? _this.element.attr('title') : _this.options.defaultTxt;
        var buttonText = this.element.attr('btntitle') ? _this.element.attr('btntitle') : _this.options.buttonText;

        var textEl = $('<span/>').text(buttonText);

        if (this.options.commonEPStyle) {
            this.fakeInput =
                $('<input type="text"/>')
                    .addClass(_this.options.inputClass)
                    .css({
                        position: 'relative',
                        zIndex: 1
                    })
                    .attr("tabindex", -1)
                    .prependTo(_this.element.parent());
            this.fakeButton =
                $('<div/>')
                    .addClass(_this.options.btnClass)
                    .text(buttonText)
                    .css({
                        position: 'relative',
                        zIndex: 1,
                        marginLeft: 5,
                        overflow: "hidden",                        
                        verticalAlign: "top"
                    })
                    .attr("tabindex", _this.options.tabindex)
                    .keypress(function (e) {
                        if (e.keyCode === enterKey) {
                            _this.element.click();
                        }
                    });

            this.element.wrap(this.fakeButton);      

            this.element
                .data('fakeInput', true)
                .css({
                    width: 'auto',
                    position: 'absolute',
                    right: 0,
                    top:0,
                    fontSize: 50,
                    height: '100%',
                    cursor: 'pointer',
                    zIndex: 2
                }).attr("tabindex", -1)
                .change(function () {
                    var $this = $(this);
                    var filename = removeFakePath($this.val());
                    _this.fakeInput.val(filename);
                })
            //added class with opacity 0, need in css .val().split('\\').pop();
                .addClass('transparent');

        } else {
            this.fakeInput =
                $('<div class="fakeInputHolder"/>')
                    .addClass(_this.options.extraClass)
                    .appendTo(_this.element.parent());
            this.fakeButton =
                $('<div/>')
                    .css({
                        position: 'relative',
                        zIndex: 1
                    })
                    .addClass('fake-button button')
                    .appendTo(_this.fakeInput);

            this.fakeButton.append(textEl);

            this.fakeText =
                $('<div/>')
                    .text(titleTxt)
                    .addClass('text-holder-fake')
                    .appendTo(_this.fakeInput);

            this.fakeExtension = $('<div/>')
                    .text(getFileExtension(titleTxt))
                    .addClass('file-extension-holder-fake')
                    .appendTo(_this.fakeInput);

            this.element
                .data('fakeInput', true)
                .css({
                    position: 'absolute',
                    right: 0,
                    top: 0,
                    fontSize: 18,
                    height: "32px",
                    zIndex: 999
                })
                .change(function () {
                    var $this = $(this);
                    var inputValue = removeFakePath($this.val());
                    var fileName = getFileName(inputValue);

                    _this.fakeText.text(fileName);
                    _this.fakeExtension.text(getFileExtension(inputValue));
                })
                .on('focus', function () {
                    _this.fakeButton.addClass('focus');
                })
                .on('blur', function () {
                    _this.fakeButton.removeClass('focus');
                })
            //added class with opacity 0, need in css;
                .addClass('transparent')
                .appendTo(_this.fakeButton);
            // resize hidden file upload to button size
            var bottonWidth = $(this.fakeButton).outerWidth(true);
            this.element.css({
                width: bottonWidth
            });

        }


    },
    destroy: function () {
        // call the base destroy function
        $.Widget.prototype.destroy.call(this);
    },
    _setOption: function (key, value) {
        if (arguments.length == 1) {
            this.options[key] = value;
            this._render();
            return this;
        } else {
            return this.options[key];
        }
    }
});
if (typeof(Sys) !== 'undefined') Sys.Application.notifyScriptLoaded();

/* eslint-enable */
